import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { isNotNil } from '@web/utils';
import { DD_MM_YYYY_HH_MM_SS_SSS } from '@web/common';
import {
  DateFormatPipe,
  getColumnKey,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { AdminProductQuantityHistoryCollectionItem } from '../../models/admin-product-quantity-history-collection-item';
import { AdminProductQuantityHistoryCollectionFilter } from '../../models/admin-product-quantity-history-collection-filter';
import { AdminProductQuantityHistoryReasonTypeComponent } from '../admin-product-quantity-history-reason-type/admin-product-quantity-history-reason-type.component';

@Component({
  selector: 'app-admin-product-quantity-history-list-custom-cell-template',
  imports: [
    DateFormatPipe,
    NoDataComponent,
    TableBodyNoReferenceCellComponent,
    AdminProductQuantityHistoryReasonTypeComponent,
  ],
  templateUrl: './admin-product-quantity-history-list-custom-cell-template.component.html',
  styleUrl: './admin-product-quantity-history-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminProductQuantityHistoryListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminProductQuantityHistoryCollectionItem, AdminProductQuantityHistoryCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminProductQuantityHistoryCollectionItem>();
  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<AdminProductQuantityHistoryCollectionItem>;
  protected readonly isNotNil = isNotNil;
  protected readonly DD_MM_YYYY_HH_MM_SS_SSS = DD_MM_YYYY_HH_MM_SS_SSS;
}
